import React from "react";
import styled from "styled-components";
import { shorten } from "@backpacker/number";
import { Dot } from "@charty/legend/item";
import { FontSize, FontWeight, Radius, Spacing, ellipsis } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import { percent } from "@tootools/number";

interface IProps {
  color: string;
  label: string;
  amount: number;
  total: number;
  locale: Locale;
}

const Root = styled.div`
  text-align: left;
  font-size: ${FontSize.Medium};
  font-weight: ${FontWeight.Normal};
  border-radius: ${Radius.Medium};
  max-width: 300px;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${Spacing.Small};
`;

const Label = styled.span`
  ${ellipsis()};
`;

const Tooltip = ({ color, label, locale, amount, total }: IProps) => {
  const percentage = percent(amount, total);
  const shortenPercentage = `${shorten(locale, percentage, 3, false, 2)}%`;
  const shortenAmount = shorten(locale, amount, 3, false, 2);
  return (
    <Root>
      <Header>
        {!!color && <Dot color={color} />}
        {!!label && <Label>{label}</Label>}
      </Header>
      <>
        {shortenPercentage} - {shortenAmount}
      </>
    </Root>
  );
};

export default Tooltip;
